<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="d-flex justify-content-between">
        <div class="section-title">
          {{ $t("Screen tax & vat overall Report") }}
        </div>
    
        <div class="d-flex align-items-center">
              <!-- <b-form-radio
              value="1"
              class="j-radio custom-radio"
              v-model="lang_id"
              >
              <div>
                <input value="1" type="radio" v-model="lang_id">
                <span>English</span>
              </div>
            </b-form-radio>
            <input value="2" type="radio" v-model="lang_id">
            <b-form-radio
            value="2"
            class="j-radio ml-1"
            v-model="lang_id"
            >
            <div>
              <input value="2" type="radio" v-model="lang_id">

              <span>العربية</span>
            </div>
          </b-form-radio> -->
          <div class="d-flex align-item-center">
                <input value="1" type="radio" v-model="lang_id">
                <span class="ml-1">English</span>
              </div>
              <div class="d-flex align-item-center ml-2">
              <input value="2" type="radio" v-model="lang_id">

              <span class="ml-1">العربية</span>
            </div>
        </div>
      </div>
      <small><em>{{ $t("* As Per Show Date") }}</em></small>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                   dropDown.selectedCinema && dropDown.selectedCinema.hasOwnProperty('cine_id')
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                >{{ $t("select") }} {{ $tc("cinema") }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder=""
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
       
              <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
                     <div class="input-material">
                       <div class="add-datepicker">

                                     <Datepicker
                         :monday-first="true"
                         type="date"
                         ref="programaticOpen"
                         v-model="fromDate"
                         v-validate="'required'"
                         @selected="onChangeDate($event, 'from')"
                       ></Datepicker>
                       <label :class="fromDate ? 'active' : ''">
                         {{ $t("fromdate") }}
                       </label>
                       </div>
                     </div>
                   </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                            ✖
                          </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <!-- Screen Filter -->
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="selectedScreen && selectedScreen.length > 0 ? 'shift-up' : 'font-weight-bold'">
                            {{ selectedScreen && selectedScreen.length > 0 ? $t("Screens") : $t("All Screens") }}
                            </label>
              <multiselect
                :options="screenList"
                v-model="selectedScreen"
                placeholder=""
                label="screen_name"
                :multiple="true"
                :close-on-select="false"
                track-by="screen_id"
              ></multiselect>
            </div>
          </div>
           <!-- Screen Filter -->

          <!-- Movie Filter -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="dropdown-curve-container">
            <label
                :class="
                  selectedMovieName && selectedMovieName.length > 0
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                > {{ selectedMovieName && selectedMovieName.length > 0 ? $t("Movies") : $t("All Movies") }}</label
              >
            <multiselect v-model="selectedMovieName" :options="allMovieNames" track-by="movie_name"
              label="movie_name" :disabled="isRoleID" :searchable="true" placeholder="Movies" :multiple="true">
            </multiselect>
          </div>
        </div>
          <!-- Movie Filter -->

          <!-- show time filter -->
               <div class=" d-flex  col-lg-3 col-xl-2 mb-2 custom-timepicker">
                             <div class="d-flex justify-content-center ">
                               <vue-timepicker manual-input v-model="start_time" id="starttime" name="starttime"
                                 :placeholder="$tc('starttime')" format="HH:mm" class="time_picker" input-width="100%" auto-scroll
                                 lazy ></vue-timepicker>
                             </div>
                     </div>
                     <div class="col-lg-3 col-xl-2 mb-2 custom-timepicker">
                             <div class="d-flex justify-content-center align-items-center">
                               <vue-timepicker manual-input v-model="end_time" id="endtime" name="endtime"
                                 :placeholder="$tc('endtime')" format="HH:mm" class="time_picker" input-width="100%" auto-scroll
                                 lazy ></vue-timepicker>
                             </div>
                     </div>
          <!-- show time filter -->

          <!-- Payment Filter -->
              <div class="col-12 col-md-6 col-lg-3 col-xl-3  mb-3">
                       <div class="dropdown-curve-container">
                        <label
                :class="
                  selectedPaymentSource && selectedPaymentSource.length > 0
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                > {{ selectedPaymentSource && selectedPaymentSource.length > 0 ? $t("Payment Mode") : $t("All Payment Mode") }}</label
              >
                         <multiselect
                           :options="paymentList"
                           v-model="selectedPaymentSource"
                           placeholder=""
                           label="pm_payment_mode"
                           :multiple="true"
                           :close-on-select="false"
                           track-by="pm_id"
                           :showLabels="false"
                         ></multiselect>
                       </div>
                     </div>
          <!-- Payment Filter -->

          <!-- Distributor filter -->
                <div class="col-lg-6 col-xl-3 mb-4">
                       <div class="d-flex align-items-center">
                         <div class="dropdown-curve-container">
                          <label :class="selectedDistributor.length > 0 ? 'shift-up' : 'font-weight-bold'">
                          {{ selectedDistributor && selectedDistributor.length > 0 ? $t("Distributors") : $t("All Distributors") }}
                         </label>
           
                           <multiselect v-model="selectedDistributor" @input="onSelectHandler($event, 'distributor')"
                             @remove="onRemoveHandler($event, 'distributor')" placeholder=""
                             :options="getDistributorReportDropdownList" label="d_company_name" track-by="d_id" :multiple="true"
                             name="d_id" id="d_id" select-label="Select" deselect-label="Remove">
                           </multiselect>
                         </div>
                       </div>
                     </div>
          <!-- Distributor filter -->

          

          <div class="col-12 col-md-6 col-lg-6 col-xl-2 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="onSubmit">
              {{ $t("fetch") }}
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="screenData.length > 0"
        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
      >
        <div class="mx-1">{{ $t("download") }} {{ $t("as") }}</div>
     
        <img
            @click="getCinemaOverallTaxAnalysisReport('Y','N')"
                class="cursor-pointer"
                height="25"
                src="@/assets/img/icons/pdf-icon.svg"
                width="25"
              />

              <img  @click="getCinemaOverallTaxAnalysisReport('N','Y')" class="cursor-pointer ml-1"
              height="25" src="@/assets/img/icons/excel.svg" width="25" />
      </div>

        <div
          class="swc-report"
        >
          <!-- <table
          class="swc-report-table"
          :class="lang_id==2?'swc-report-table reverse-order ':'swc-report-table order '"  
            border="1"
          >
            <thead class="bg-lightgrey">
              <tr>
                <th>{{  trans("showdate",lang_id) }}</th>
                <th>{{ trans("showTime",lang_id)  }}</th>
                <th>{{ trans("screen",lang_id) }}</th>
                <th>{{ trans("movie",lang_id) }}</th>
                <th>{{ trans("distributioncompany",lang_id) }}</th>
                <th>{{ trans("ticketcosttotal",lang_id) }}</th>
                <th>{{ trans("ticketcostforentry",lang_id)}}</th>
                <th>{{ trans("ticketscount",lang_id)}}</th>
                <th>{{ trans("ticketscost",lang_id) }}</th>
                <th>{{ trans("amusementtax",lang_id)}}</th>
                <th colspan="6">{{ trans("tax",lang_id) }}</th>
                <th>{{ trans("taxtotal",lang_id) }}</th>
                <th>{{ trans("totalafterasumetax",lang_id) }}</th>
                <th>{{ trans("vat",lang_id) }}</th>
                <th>{{ trans("netaftervat",lang_id) }}</th>
              </tr>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th>{{ trans("socialsubside",lang_id) }}</th>
                <th>{{ trans("cinemasubside",lang_id) }}</th>
                <th>{{ trans("policesubside",lang_id) }}</th>
                <th>{{ trans("daransubside",lang_id) }}</th>
                <th>{{ trans("servicessubside",lang_id) }}</th>
                <th>{{ trans("sports",lang_id) }}</th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>

              </tr>
            </thead>
            <tbody v-if="screenData.length">
              <template v-for="screen in screenData">

                <tr :class="[{ 'text-right': selectedLanguage === 'ar', 'text-left': selectedLanguage !== 'ar' }, 'bg-lightgrey']">
                  <td :class="lang_id==1?'text-left':'text-right'" colspan="20">{{ screen.screen_name }}</td>
                </tr>

                <template v-for="showDate in screen.screenData">
                  <tr v-for="show in showDate.showDateData">
                    <td class="text-left">{{ show.show_date }} - {{ show.new_ss_id }}</td>
                    <td class="text-left">{{ show.show_time }}</td>
                    <td class="text-left">{{ show.screen_name }}</td>
                    <td class="text-left">{{ lang_id==1?show.movie_title:show.movie_title_4?show.movie_title_2:show.movie_title}}</td>
                    <td class="text-left">{{ show.distributor_name }}</td>

                    <td class="text-right">
                      {{ parseFloat(show.ticket_gross ||0).toFixed(2) }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.ticket_net ||0).toFixed(2) || 0 }}
                    </td>
                    <td class="text-right">{{ show.tickets_no ||0 }}</td>
                    <td class="text-right">
                      {{ parseFloat(show.tickets_gross ||0).toFixed(2) || 0 }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.entertainment_tax ||0).toFixed(2) }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.fixed_fees.social ||0).toFixed(2) || 0.0 }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.fixed_fees.cinema ||0).toFixed(2) || 0.0 }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.fixed_fees.police ||0).toFixed(2) || 0.0 }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.fixed_fees.daran ||0).toFixed(2) || 0.0 }}
                    </td>
                    <td class="text-right">
                      {{
                        parseFloat(show.fixed_fees.services ||0).toFixed(2) || 0.0
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        parseFloat(show.fixed_fees.sports ||0).toFixed(2) || 0.0
                      }}
                    </td>

                    <td class="text-right">
                      {{ parseFloat(show.total_tax ||0).toFixed(2) || 0.0 }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.total_after_tax ||0).toFixed(2) || 0.0 }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.total_vat ||0).toFixed(2) || 0.0 }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.total_after_vat ||0).toFixed(2) || 0.0 }}
                    </td>
                  </tr>
                </template>


                <tr class="bg-lightgrey text-left">
                  <td colspan="7" :class="lang_id==1?'text-left':'text-right'">{{ trans("total",lang_id) }}</td>
                  <td class="text-right">{{ screen.grandTotal.tickets_no ||0 }}</td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.tickets_gross ||0).toFixed(2) ||
                      0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.entertainment_tax ||0).toFixed(
                        2
                      ) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(screen.grandTotal.social||0).toFixed(2) || 0.0 }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(screen.grandTotal.cinema ||0).toFixed(2) || 0.0 }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(screen.grandTotal.police||0).toFixed(2) || 0.0 }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(screen.grandTotal.daran ||0).toFixed(2) || 0.0 }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.services || 0).toFixed(2) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.sports ||0).toFixed(2) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.total_tax).toFixed(2) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.total_after_tax).toFixed(
                        2
                      ) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.total_vat).toFixed(2) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.total_after_vat).toFixed(
                        2
                      ) || 0.0
                    }}
                  </td>
                </tr>


              </template>
              <tr class="bg-lightgrey">
                <td colspan="7" :class="lang_id==1?'text-left':'text-right'">{{trans("grandtotal",lang_id)}}</td>
                <td class="text-right">{{ grandTotal.total_tickets_no ? grandTotal.total_tickets_no  : "0.00" }}</td>

                <td class="text-right">{{ grandTotal.total_tickets_gross ? parseFloat(grandTotal.total_tickets_gross || 0).toFixed(2) : "0.00" }}</td>

                <td class="text-right">{{ grandTotal.total_entertainment_tax ? parseFloat(grandTotal.total_entertainment_tax || 0).toFixed(2) : "0.00" }}</td>

                <td class="text-right">{{ grandTotal.social ? parseFloat(grandTotal.social || 0).toFixed(2) : "0.00" }}</td>

                <td class="text-right">{{ grandTotal.cinema ? parseFloat(grandTotal.cinema || 0).toFixed(2) : "0.00" }}</td>

                <td class="text-right">{{ grandTotal.police ? parseFloat(grandTotal.police || 0).toFixed(2) : "0.00" }}</td>


                <td class="text-right">{{ grandTotal.daran ? parseFloat(grandTotal.daran ||0).toFixed(2) : "0.00" }}</td>

                <td class="text-right">{{ grandTotal.services ? parseFloat(grandTotal.services ||0).toFixed(2) : "0.00" }}</td>
                <td class="text-right">{{ grandTotal.sports ? parseFloat(grandTotal.sports || 0 ||0).toFixed(2) : "0.00" }}</td>

                <td class="text-right">{{ grandTotal.total_tax ? parseFloat(grandTotal.total_tax).toFixed(2) : "0.00" }}</td>

              <td class="text-right">{{ grandTotal.total_after_tax ? parseFloat(grandTotal.total_after_tax).toFixed(2) : "0.00" }}</td>

              <td class="text-right">{{ grandTotal.total_vat ? parseFloat(grandTotal.total_vat).toFixed(2) : "0.00" }}</td>

              <td class="text-right">{{ grandTotal.total_after_vat ? parseFloat(grandTotal.total_after_vat).toFixed(2) : "0.00" }}</td>

              </tr>
            </tbody>
            <tbody v-else>
              <td colspan="11">No Records</td>
            </tbody>
          </table> -->

          <table  class="swc-report-table" :class="lang_id == 2 ? 'swc-report-table reverse-order' : 'swc-report-table order'" border="1">
  <tbody v-if="screenData.length">
    <template v-for="screen in screenData">
      <!-- Screen name title -->
      <tr   :class="[{ 'text-right': selectedLanguage === 'ar', 'text-left': selectedLanguage !== 'ar' }]" style="background-color: lightblue; font-weight: bold; height: 50px; font-size: 20px;">
        <td :class="lang_id == 1 ? 'text-left' : 'text-right'" colspan="20">{{ screen.screen_name }}</td>
      </tr>

      <!-- Column headers -->
      <tr class="bg-lightgrey">
        <th>{{ trans("showdate", lang_id) }}</th>
        <th>{{ trans("showTime", lang_id) }}</th>
        <th>{{ trans("screen", lang_id) }}</th>
        <th>{{ trans("movie", lang_id) }}</th>
        <th>{{ trans("distributioncompany", lang_id) }}</th>
        <th>{{ trans("ticketcosttotal", lang_id) }}</th>
        <th>{{ trans("ticketcostforentry", lang_id)}}</th>
        <th>{{ trans("ticketscount", lang_id)}}</th>
        <th>{{ trans("ticketscost", lang_id) }}</th>
        <th>{{ trans("amusementtax", lang_id)}}</th>
        <th colspan="6">{{ trans("Additionalfees", lang_id) }}</th>
        <th>{{ trans("taxtotal", lang_id) }}</th>
        <th>{{ trans("totalafterasumetax", lang_id) }}</th>
        <th>{{ trans("vat", lang_id) }}</th>
        <th>{{ trans("netaftervat", lang_id) }}</th>
      </tr>
      <tr class="bg-lightgrey">
        <th colspan="10"></th>
        <th>{{ trans("socialsubside", lang_id) }}</th>
        <th>{{ trans("cinemasubside", lang_id) }}</th>
        <th>{{ trans("policesubside", lang_id) }}</th>
        <th>{{ trans("daransubside", lang_id) }}</th>
        <th>{{ trans("servicessubside", lang_id) }}</th>
        <th>{{ trans("sports", lang_id) }}</th>
        <th colspan="4"></th>
      </tr>

      <!-- Data rows -->
      <template v-for="showDate in screen.screenData">
        <tr v-for="show in showDate.showDateData">
          <td class="text-left">{{ show.show_date }}</td>
                    <td class="text-left">{{ show.show_time }}</td>
                    <td class="text-left">{{ show.screen_name }}</td>
                    <td class="text-left">{{ lang_id==1?show.movie_title:show.movie_title_4?show.movie_title_2:show.movie_title}}</td>
                    <td class="text-left">{{ show.distributor_name }}</td>

                    <td class="text-right">
                      {{ parseFloat(show.ticket_gross ||0).toFixed(2) }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.ticket_net ||0).toFixed(2) || 0 }}
                    </td>
                    <td class="text-right">{{ show.tickets_no ||0 }}</td>
                    <td class="text-right">
                      {{ parseFloat(show.tickets_gross ||0).toFixed(2) || 0 }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.entertainment_tax ||0).toFixed(2) }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.fixed_fees.social ||0).toFixed(2) || 0.0 }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.fixed_fees.cinema ||0).toFixed(2) || 0.0 }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.fixed_fees.police ||0).toFixed(2) || 0.0 }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.fixed_fees.daran ||0).toFixed(2) || 0.0 }}
                    </td>
                    <td class="text-right">
                      {{
                        parseFloat(show.fixed_fees.services ||0).toFixed(2) || 0.0
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        parseFloat(show.fixed_fees.sports ||0).toFixed(2) || 0.0
                      }}
                    </td>

                    <td class="text-right">
                      {{ parseFloat(show.total_tax ||0).toFixed(2) || 0.0 }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.total_after_tax ||0).toFixed(2) || 0.0 }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.total_vat ||0).toFixed(2) || 0.0 }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(show.total_after_vat ||0).toFixed(2) || 0.0 }}
                    </td>
        </tr>
      </template>

      <!-- Screen subtotal -->
      <tr class="bg-lightgrey text-left">
        <td colspan="7" :class="lang_id==1?'text-left':'text-right'">{{ trans("total",lang_id) }}</td>
                  <td class="text-right">{{ screen.grandTotal.tickets_no ||0 }}</td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.tickets_gross ||0).toFixed(2) ||
                      0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.entertainment_tax ||0).toFixed(
                        2
                      ) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(screen.grandTotal.social||0).toFixed(2) || 0.0 }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(screen.grandTotal.cinema ||0).toFixed(2) || 0.0 }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(screen.grandTotal.police||0).toFixed(2) || 0.0 }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(screen.grandTotal.daran ||0).toFixed(2) || 0.0 }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.services || 0).toFixed(2) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.sports ||0).toFixed(2) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.total_tax).toFixed(2) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.total_after_tax).toFixed(
                        2
                      ) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.total_vat).toFixed(2) || 0.0
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(screen.grandTotal.total_after_vat).toFixed(
                        2
                      ) || 0.0
                    }}
                  </td>
      </tr>
      <!-- Gap for each screen -->
      <tr><td colspan="20" style="height: 20px; border: none;"></td></tr>
    </template>

    <!-- Grand total -->
     <!-- Grand Total Column Headers -->
<tr class="bg-lightgrey">
  <th colspan="7"></th>
  <th>{{ trans("ticketscount", lang_id)}}</th>
  <th>{{ trans("ticketscost", lang_id) }}</th>
  <th>{{ trans("amusementtax", lang_id)}}</th>
  <th colspan="6">{{ trans("tax", lang_id) }}</th>
  <th>{{ trans("taxtotal", lang_id) }}</th>
  <th>{{ trans("totalafterasumetax", lang_id) }}</th>
  <th>{{ trans("vat", lang_id) }}</th>
  <th>{{ trans("netaftervat", lang_id) }}</th>
</tr>
<tr class="bg-lightgrey">
  <th colspan="10"></th>
  <th>{{ trans("socialsubside", lang_id) }}</th>
  <th>{{ trans("cinemasubside", lang_id) }}</th>
  <th>{{ trans("policesubside", lang_id) }}</th>
  <th>{{ trans("daransubside", lang_id) }}</th>
  <th>{{ trans("servicessubside", lang_id) }}</th>
  <th>{{ trans("sports", lang_id) }}</th>
  <th colspan="4"></th>
</tr>

    <tr class="bg-lightgrey">
      <td colspan="7" :class="lang_id==1?'text-left':'text-right'">{{trans("grandtotal",lang_id)}}</td>
                <td class="text-right">{{ grandTotal.total_tickets_no ? grandTotal.total_tickets_no  : "0.00" }}</td>

                <td class="text-right">{{ grandTotal.total_tickets_gross ? parseFloat(grandTotal.total_tickets_gross || 0).toFixed(2) : "0.00" }}</td>

                <td class="text-right">{{ grandTotal.total_entertainment_tax ? parseFloat(grandTotal.total_entertainment_tax || 0).toFixed(2) : "0.00" }}</td>

                <td class="text-right">{{ grandTotal.social ? parseFloat(grandTotal.social || 0).toFixed(2) : "0.00" }}</td>

                <td class="text-right">{{ grandTotal.cinema ? parseFloat(grandTotal.cinema || 0).toFixed(2) : "0.00" }}</td>

                <td class="text-right">{{ grandTotal.police ? parseFloat(grandTotal.police || 0).toFixed(2) : "0.00" }}</td>


                <td class="text-right">{{ grandTotal.daran ? parseFloat(grandTotal.daran ||0).toFixed(2) : "0.00" }}</td>

                <td class="text-right">{{ grandTotal.services ? parseFloat(grandTotal.services ||0).toFixed(2) : "0.00" }}</td>
                <td class="text-right">{{ grandTotal.sports ? parseFloat(grandTotal.sports || 0 ||0).toFixed(2) : "0.00" }}</td>

                <td class="text-right">{{ grandTotal.total_tax ? parseFloat(grandTotal.total_tax).toFixed(2) : "0.00" }}</td>

              <td class="text-right">{{ grandTotal.total_after_tax ? parseFloat(grandTotal.total_after_tax).toFixed(2) : "0.00" }}</td>

              <td class="text-right">{{ grandTotal.total_vat ? parseFloat(grandTotal.total_vat).toFixed(2) : "0.00" }}</td>

              <td class="text-right">{{ grandTotal.total_after_vat ? parseFloat(grandTotal.total_after_vat).toFixed(2) : "0.00" }}</td>

    </tr>
  </tbody>

  <tbody v-else>
    <thead>
      <tr class="bg-lightgrey">
        <th>{{ trans("showdate", lang_id) }}</th>
        <th>{{ trans("showTime", lang_id) }}</th>
        <th>{{ trans("screen", lang_id) }}</th>
        <th>{{ trans("movie", lang_id) }}</th>
        <th>{{ trans("distributioncompany", lang_id) }}</th>
        <th>{{ trans("ticketcosttotal", lang_id) }}</th>
        <th>{{ trans("ticketcostforentry", lang_id)}}</th>
        <th>{{ trans("ticketscount", lang_id)}}</th>
        <th>{{ trans("ticketscost", lang_id) }}</th>
        <th>{{ trans("amusementtax", lang_id)}}</th>
        <th colspan="6">{{ trans("Additionalfees", lang_id) }}</th>
        <th>{{ trans("taxtotal", lang_id) }}</th>
        <th>{{ trans("totalafterasumetax", lang_id) }}</th>
        <th>{{ trans("vat", lang_id) }}</th>
        <th>{{ trans("netaftervat", lang_id) }}</th>
      </tr>
      <tr class="bg-lightgrey">
        <th colspan="10"></th>
        <th>{{ trans("socialsubside", lang_id) }}</th>
        <th>{{ trans("cinemasubside", lang_id) }}</th>
        <th>{{ trans("policesubside", lang_id) }}</th>
        <th>{{ trans("daransubside", lang_id) }}</th>
        <th>{{ trans("servicessubside", lang_id) }}</th>
        <th>{{ trans("sports", lang_id) }}</th>
        <th colspan="4"></th>
      </tr>
    </thead>
    <tr><td colspan="20">No Records</td></tr>
  </tbody>
</table>

        </div>
    </div>
  </div>
</template>
    
    <script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import NewReportService from "../../../services/NewReportService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";
import { mapState, mapActions, mapGetters } from "vuex";
// import LangSwitcher from "./LangSwitcher.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
 import { authenticationService } from "@/services/AuthenticationService";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
    // LangSwitcher,
    VueTimepicker,
  },
  data() {
    return {
       selectedMovieName: [],
            allMovieNames: [],
      selectedDistributor:[],
       paymentList:[],
      selectedPaymentSource:[],
       start_time:"",
      end_time:"",
      BASEURL,
      isRoleID: false,
      submitted: false,
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape",
        },
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
        selectedCinemaAddres: null,
      },
      fromDate: new Date(),
      toDate: new Date(),
      advancedSalesrecords: [],
      grandTotal: {},
      screenData: [],
      selectedScreen: [],
      screenList: [],
      selectedLanguage: "en",
      lang_id:"1"
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    this.getPaymentTypes();
     this.fetchReportDistributorsList();
  },
  watch: {
        fromDate() {
        this.getCinemaOverallTaxAnalysisReport("N", "N", "filter");   
      },
      toDate() {
        this.getCinemaOverallTaxAnalysisReport("N", "N", "filter");
      },
  },
  mounted() {},
  computed: {
    ...mapGetters([
      "getDistributorReportDropdownList"
      //   "getDistributorReportMoviesList",
    ]),
    currentSelectedLanguage() {
      return this.$store.getters.GET_SELECTED_HEADER_LANGUAGE;
    },
      paymentModeId() {
          let text = ``;
          if (this.selectedPaymentSource.length > 0) {
            text = this.selectedPaymentSource.map(x => x.pm_id).join(",");
          }
    
          return text;
        },
          distributorIds() {
              let text = ``;
              if (this.selectedDistributor.length > 0) {
                text = this.selectedDistributor.map(x => x.d_id).join(",");
              }
        
              return text;
            },
  },
  methods: {
    moment,
     onSelectHandler(event,type){
                if (type =="distributor") {
                this.d_id = event.d_id;
                // this.selectedMovie = [];
                // this.MovieList = [];
                 this.fetchDistributorMovies();
                // this.selectedDistributor = event;
              }
              },
               onRemoveHandler(event,type){
                      
                  },
      onChangeDate(e, type){
        if(type == 'from'){
          this.toDate = new Date(e);
          this.$forceUpdate();
        }
      },
    fetchDistributorMovies() {
          if (!this.dropDown.selectedCinemaId) {
            this.$toasted.show("Please Select Cinema");
            this.selectedDistributor = [];
            this.$forceUpdate();
          } else {
            this.MovieList = [];
            let payload = {
              fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
              cinema_id: this.dropDown.selectedCinemaId,
                cinema_name: this.dropDown.selectedCinemaName,
                cinema_address: this.dropDown.selectedCinemaAddres,
              d_id: this.distributorIds,
              d_company_name: this.selectedDistributor
                .map(x => x.d_company_name)
                .join(","),
              country_id: authenticationService.get("BRGLOPCO"),
              filter_with_key: "ss_actual_start_date"
            };
            ReportService.GetDistributorMovieFormat(payload)
              .then(response => {
                const { data } = response;
                if (data && data.status && data.Records) {
                  this.MovieList = data.Records;
                } else
                  this.$toasted.show(data.message || "Opps! Something went wrong");
              })
              .catch(error => {
                this.$toasted.show(
                  "Catch Error on ReportStore fetchDistributorMovies",
                  error
                );
              });
          }
        },
       ...mapActions([
          "fetchReportDistributorsList",
        ]),
    getPaymentTypes() {
      let body = {
        tableName: "ms_payment_modes",
        pm_is_active: "Y"
      };
      MasterService.GetActiveList(body).then(response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records.length > 0) {
            this.paymentList = data.Records;
           
          }
        } else this.$toasted.show(data.message || "Opps! Something went wrong");
      });
    },
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.dropDown.selectedCinemaAddres = event.cine_address;
      this.$store.dispatch("selectDropdownCinema", event);
      this.getCinemaScreens();
    },
    onSubmit() {
      this.getCinemaOverallTaxAnalysisReport();
    },
    async getCinemaScreens(index) {
      try {
        const response = await MasterService.GetActiveList({
          tableName: "screens",
          screen_is_active: "Y",
          cinema_id: this.dropDown.selectedCinemaId,
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.screenList = data.Records;
        } else {
          console.log("show error:", data.message);
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    async getCinemaOverallTaxAnalysisReport(isPdf = "N",isExcel="N",type = "") {
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader;
      try {
        let screen_id = [];
        this.screenData = [];
        if (this.selectedScreen.length) {
          screen_id = this.selectedScreen.map((screen) => screen.screen_id);
        }
        loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName,
          cinema_address: this.dropDown.selectedCinemaAddres,
           fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          screen_id,
          start_time:this.start_time,
          end_time:this.end_time,
          payment_mode_id:this.paymentModeId,
          isPdf,
          isExcel,
          lang_id:this.lang_id,
          language: this.selectedLanguage,
          d_id:this.distributorIds,
        };
          if (type === "filter") {
            payload["type"] = "filter";
          }
           if (this.selectedMovieName.length) {
                payload["selectedMovieName"] = this.selectedMovieName.map(
                  (item) => {
                    return item.movie_name;
                  }
                );
              }
        let response = await NewReportService.getCinemaTaxVatAnalysisReport( payload);
        const { data } = response;
          if (!data.status) return this.$toasted.show(data.message);
            if (type == "filter") {
                    this.allMovieNames = [...data.movieNamesData];
                  } 
       else  {
          this.screenData = data.Records;
          this.grandTotal=data.grandTotal;
          if (isPdf == "Y" && data.pdfPath) {
            window.open(data.pdfPath, "_blank");
          }
          if (isExcel == "Y" && data.excelPath) {
            window.open(data.excelPath, "_blank");
          }
        } 
      } catch (error) {
        console.log(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    updateLanguage(lang) {
      this.selectedLanguage = lang;
      // console.log("this.selectedLanguage:", this.selectedLanguage);
    },
  },
};
</script>
    
    <style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}

.swc-report-table th {
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}
.rtl-table {
  direction: rtl;
  text-align: right;
}
.rtl-table-scroll {
  direction: rtl;
}
.text_right{
  text-align: right;
}
.reverse-order{
  direction: rtl;
}
.order{
  direction: ltr
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/cinemaTaxvatAnalysis.vue